import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { CommunicationService } from '../../../core';

@Component({
  selector: 'kt-app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, ReactiveFormsModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  currentYear = new Date().getFullYear();

  private fb = inject(FormBuilder);
  private communicationService = inject(CommunicationService);
  private env = environment;

  subscriberForm : FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]]
  });

  isLoading = false;
  isSuccess = false;
  isError = false;
  errorMsg = '';

  onSubscribe(): void {
    if(this.subscriberForm.invalid) {
      this.isError = true;
      this.errorMsg = 'Please enter a valid email address.';
      this.subscriberForm.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    this.isError = false;
    this.isSuccess = false;

    const payload = {
      ...this.subscriberForm.value,
      applicationId: this.env.appId
    }

    this.communicationService.sendSubscriberRequest(payload).subscribe({
      next: () => {
        this.isLoading = false;
        this.isSuccess = true;
        this.subscriberForm.reset();
        this.resetRequest();
        },
      error: (err) => {
        this.isLoading = false;
        this.isError = true;

        if (err.status === 409) {
          this.errorMsg =
            err.error?.detail?.split('\n')[0] ||
            'This email is already subscribed.';
        } else {
          this.errorMsg = 'Something went wrong. Please try again.';
        }
      }
    });
  }

  private resetRequest(): void {
    setTimeout(() => {
      this.isSuccess = false;
      this.isError = false;
      this.errorMsg = '';
    }, 5000);
  }
}
